import { appConfig } from '../../../../config'
import { EventRequest } from '@estercare/ester-shared'

export const postEvent = async ({
  event,
  accessToken,
}: {
  event: EventRequest
  accessToken: string
}): Promise<Response> => {
  const response = await fetch(`${appConfig.serverRootUrl}/api/private/event`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ ...event }),
  })
  return response
}
